import { AfterContentInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { PagedResponse } from "@models/response.model";
import { ScrollListItemModel } from "@components/scroll-list/models/scroll-list-item.model";
import { TranslateService } from "@ngx-translate/core";
import { StrainMeasurementStatus } from "@app/strain/registry/models/strain-measurement-status.model";
import { StrainMeasurement } from "@app/strain/common/models/strain-registry-measurement.model";
import { StrainReportModel } from "@app/strain/common/models/strain-report.model";


@Component({
    selector: 'app-strain-measurements-list',
    templateUrl: './strain-measurements-list.component.html',
    styleUrls: ['./strain-measurements-list.component.scss']
})
export class StrainMeasurementsListComponent implements AfterContentInit {

    @Input() isLoading = false;
    @Input() canEdit = true;
    @Input() canDelete = false;
    @Input() measurements: PagedResponse<StrainMeasurement>;

    @Output() reportClick = new EventEmitter<any>();
    @Output() reportDelete = new EventEmitter<any>();
    @Output() actionClick = new EventEmitter<any>();
    @Output() measurementDelete = new EventEmitter<any>();

    items: PagedResponse<ScrollListItemModel>;

    selectedIndex = -1;

    constructor(private translate: TranslateService) {

    }

    ngAfterContentInit(): void {
    }

    onSelect(event: number) {
        this.selectedIndex = event;
    }

    onReportClick(event: any) {
        this.reportClick.emit(event);
    }

    onReportDelete(event: StrainReportModel) {
        this.reportDelete.emit(event)
    }

    buildSubtitle(measurement: StrainMeasurement) {
        const status = this.translate.instant('admin.strain.registry.details.measurements.status.' + measurement.status);

        if (measurement.maxValue) {
            return status +
                ' | '
                + this.translate.instant('admin.strain.registry.details.maxDeformationValue', {value: measurement.maxDeformationValue});
        }
        return status;
    }

    onActionClicked(event: any) {
        this.actionClick.emit(event);
    }

    onDeleteClicked(event: any) {
        this.measurementDelete.emit(event);
    }

    computeTextColor(measurement: StrainMeasurement) {
        switch (measurement.status) {
            case StrainMeasurementStatus.OK:
                return 'green-text';
            case StrainMeasurementStatus.NOK:
                return 'yellow-text';
            case StrainMeasurementStatus.NotDone:
                return 'red-text';
        }
        return 'default';
    }

    getRightIcon(measurement: StrainMeasurement) {
        if (measurement.status === StrainMeasurementStatus.NotDone) {
            return '';
        }

        if (!this.canEdit) {
            return 'fa-share';
        }

        return measurement.status === StrainMeasurementStatus.InProgress ? 'fa-share' : measurement.isInitialMeasurement ? 'fa-plus' : 'fa-pencil';
    }
}
